import { Component, OnInit } from '@angular/core';
import { ConfirmServiceService } from './confirm-service.service';
import { CommonModule } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-confirm-dailog-token',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dailog-token.component.html',
  styleUrl: './confirm-dailog-token.component.css',
})
export class ConfirmDailogTokenComponent implements OnInit {
  message: any;

  constructor(private confirmDialogService: ConfirmServiceService) {}

  ngOnInit() {
    //this function waits for a message from alert service, it gets
    //triggered when we call this from any other component

    this.confirmDialogService.getMessage().subscribe((message) => {
      $('#tokenConfirmation').modal('show');
      this.message = message;
    });
  }
}
